module.exports = __webpack_public_path__ + "static/media/distances_GO_C.a8ad5bb1.png";